import type { UseMutationOptions, UseMutationResult } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { DeleteTagMutationResponse, DeleteTagPathParams } from "../types/DeleteTag";

/**
 * @link /api/ms-content-infoportal-backend/v1/admin/tags/:tagId
 */

export function useDeleteTag <TData = DeleteTagMutationResponse, TError = unknown>(tagId: DeleteTagPathParams["tagId"], options: {
          mutation?: UseMutationOptions<ResponseConfig<TData>, TError, void>,
          client?: Partial<Parameters<typeof client<TData, TError, void>>[0]>,
      } = {}): UseMutationResult<ResponseConfig<TData>, TError, void> {
  const { mutation: mutationOptions, client: clientOptions = {} } = options ?? {};

  return useMutation<ResponseConfig<TData>, TError, void>({
    mutationFn: () => {
      
      return client<TData, TError, void>({
        method: "delete",
        url: `/api/ms-content-infoportal-backend/v1/admin/tags/${tagId}`,
        
        
        
        ...clientOptions
      });
    },
    ...mutationOptions
  });
};
